import { AccountComponent } from './account/account.component';
import { CreateaccountComponent } from './createaccount/createaccount.component';
import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
// import { RegistrationComponent } from './registration/registration.component';
// import { RegisterComponent } from './register/register.component';
import { RegisterBusinessComponent } from './register-business/register-business.component';
import { LoginDetailsComponent } from './login-details/login-details.component';
import { TwofactorLoginComponent } from './twofactor-login/twofactor-login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { IdmeVerificationComponent } from './idme-verification/idme-verification.component';
import { CheckIdmeComponent } from './check-idme/check-idme.component';
import { PendingVerificationComponent } from './pending-verification/pending-verification.component';
import { ErrorComponent } from './error/error.component';
import { UnverifiedBusinessComponent } from './unverified-business/unverified-business.component';
import { LinkExpiredComponent } from './link-expired/link-expired.component';
import { BusinessesComponent } from './businesses/businesses.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { InvitedUsersComponent } from './invited-users/invited-users.component';
import { AgreementComponent } from './agreement/agreement.component';
import { ViewNotificationsComponent } from './view-notifications/view-notifications.component';
import { SecurityComponent } from '../dashboard/security/security.component';
import { AuthMessageComponent } from './auth-message/auth-message.component';
import { IdentityVerificationComponent } from './identity-verification/identity-verification.component';
import { ViewTaskManagementComponent } from './view-task-management/view-task-management.component';

const routes: Routes = [
  {
    path: ''
    , component: AccountComponent
    , children: [
      {
        path: '',
        component: LoginComponent
      },
      {
        path: 'two_factor_authentication',
        component: TwofactorLoginComponent
      },
      {
        path: 'verification',
        component: IdmeVerificationComponent
      },
      {
        path: 'identity-verification',
        component: IdentityVerificationComponent
      },
      {
        path: 'link_expired',
        component: LinkExpiredComponent
      },
      {
        path: 'pending_approval',
        component: PendingVerificationComponent
      },
      {
        path: 'forgot-password'
        , component: ForgotPasswordComponent
      },
      {
        path: 'createaccount'
        , component: CreateaccountComponent
      },
      {
        path: 'register_business'
        , component: RegisterBusinessComponent
      },
      {
        path: 'Login_Details'
        , component: LoginDetailsComponent
      },
      {
        path: 'email_already_verified'
        , component: ErrorComponent
      },
      {
        path: 'email_verified'
        , component: ErrorComponent
      },
      {
        path: 'post-register'
        , component: ErrorComponent
      },
      {
        path: 'register-successful'
        , component: ErrorComponent
      },
      {
        path: 'invite-user'
        , component: InvitedUsersComponent
      },
      {
        path: 'terms-and-conditions'
        , component: AgreementComponent
      }

    ]
  },
  {
    path: 'standard-auth',
    component: CheckIdmeComponent
  },
  {
    path: 'current_business',
    component: UnverifiedBusinessComponent
    , children: [{
      path: '',
      component: BusinessesComponent
    },
    {
      path: 'profile',
      component: UserProfileComponent
    },
    {
      path: 'Security_Settings'
      , component: SecurityComponent
    },
    {
      path: 'auth-message',
      component:AuthMessageComponent
    },
    {
      path: 'view-task-management/:id',
      component: ViewTaskManagementComponent
    },
  ]
  },
  // {
  //   path: 'view-task-management/:id',
  //   component: ViewTaskManagementComponent
  // },
  {
    path: 'profile' ,
    component: UnverifiedBusinessComponent
    , children : [{
      path: '',
      component : UserProfileComponent
    } ,
  {
    path : 'view-notifications',
    component : ViewNotificationsComponent
  }]
  }
  ,
  {
    path: 'dashboard',
    loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'register',
    loadChildren: () => import('../register/register.module').then(m => m.RegisterModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
